import { render, staticRenderFns } from "./online.vue?vue&type=template&id=33521ae8&scoped=true&"
import script from "./online.vue?vue&type=script&lang=js&"
export * from "./online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33521ae8",
  null
  
)

export default component.exports